export default "/images/vendor/flag-icon-css/flags/4x3/cu.svg?1768da183b71efa6856128a9f014bb44";